import { render } from "./WX.vue?vue&type=template&id=68d9403f&scoped=true"
import script from "./WX.vue?vue&type=script&lang=js"
export * from "./WX.vue?vue&type=script&lang=js"

import "./WX.vue?vue&type=style&index=0&id=68d9403f&scoped=true&lang=css"

import exportComponent from "/home/greg/code/avxcwx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d9403f"]])

export default __exports__